import React from "react";
import * as PRTNR from "../../prtnr";
import {
  Frame1406,
  BusinessInformation,
  Frame1407,
  Frame1409,
  Frame1409_0001,
} from "./styles";

export default function EnterpriseInfoForm({
  formData,
  setFormData,
  hasSubmitted,
  fieldErrors,
  handleInputChange,
  setGeneralError,
  setFieldErrors,
}) {
  return (
    <Frame1406>
      <BusinessInformation>Business Information</BusinessInformation>
      <Frame1407>
        <PRTNR.Input
          name="company_name"
          label="Company name"
          value={formData.company_name}
          onChange={(e) => handleInputChange("company_name", e.target.value)}
          required
          error={hasSubmitted && fieldErrors.company_name}
          errorMessage={fieldErrors.company_name}
          enableTracking={true}
        />

        <PRTNR.Input
          name="company_website_url"
          label="Company website"
          value={formData.company_website_url}
          onChange={(e) =>
            handleInputChange("company_website_url", e.target.value)
          }
          placeholder="https://example.com"
          required
          error={hasSubmitted && fieldErrors.company_website_url}
          errorMessage={fieldErrors.company_website_url}
          enableTracking={true}
        />

        <PRTNR.Input
          id="companyAddress"
          name="company_address"
          label="Company address"
          value={formData.company_address}
          onChange={(e) => handleInputChange("company_address", e.target.value)}
          required
          error={hasSubmitted && fieldErrors.company_address}
          errorMessage={fieldErrors.company_address}
          enableTracking={true}
        />

        <Frame1409_0001>
          <PRTNR.Input
            name="company_no"
            label="Company no"
            value={formData.company_no}
            onChange={(e) => handleInputChange("company_no", e.target.value)}
            required
            error={hasSubmitted && fieldErrors.company_no}
            errorMessage={fieldErrors.company_no}
            enableTracking={true}
          />

          <PRTNR.Input
            name="tax_identification_no"
            label="Tax identification number"
            value={formData.tax_identification_no}
            onChange={(e) =>
              handleInputChange("tax_identification_no", e.target.value)
            }
            required
            error={hasSubmitted && fieldErrors.tax_identification_no}
            errorMessage={fieldErrors.tax_identification_no}
            enableTracking={true}
          />
        </Frame1409_0001>

        <Frame1409>
          <PRTNR.Select
            name="is_uk_registered"
            label="Is your company a UK partnership?"
            options={[
              { value: "", label: "Please select" },
              { value: "false", label: "No" },
              { value: "true", label: "Yes" },
            ]}
            value={formData.is_uk_registered?.toString() || ""}
            onChange={(e) => {
              const isUkRegistered = e.target.value === "true";
              setFormData({
                ...formData,
                is_uk_registered:
                  e.target.value === "" ? null : isUkRegistered,
                unique_taxpayer_reference_utr: isUkRegistered
                  ? formData.unique_taxpayer_reference_utr
                  : "",
              });
              setGeneralError("");
              setFieldErrors((prev) => ({
                ...prev,
                is_uk_registered: "",
              }));
            }}
            error={hasSubmitted && fieldErrors.is_uk_registered}
            errorMessage={fieldErrors.is_uk_registered}
            required
          />
        </Frame1409>

        <PRTNR.Input
          name="unique_taxpayer_reference_utr"
          disabled={!formData?.is_uk_registered}
          label="Unique taxpayer reference (UTR)"
          value={formData.unique_taxpayer_reference_utr}
          onChange={(e) =>
            handleInputChange("unique_taxpayer_reference_utr", e.target.value)
          }
          required={formData?.is_uk_registered}
          error={hasSubmitted && fieldErrors.unique_taxpayer_reference_utr}
          errorMessage={fieldErrors.unique_taxpayer_reference_utr}
          enableTracking={true}
        />
      </Frame1407>
    </Frame1406>
  );
}
